import { useEffect, useState } from 'react';
import { getMessaging, getToken } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyBr7-QOfMLVVW-DDhdzvFpjXzcalvgrAi0",
  authDomain: "flickers-428323.firebaseapp.com",
  projectId: "flickers-428323",
  storageBucket: "flickers-428323.appspot.com",
  messagingSenderId: "2176391335",
  appId: "1:2176391335:web:3dce72fd91f712a5c1e382"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const useNotifications = () => {
  const [notificationsToken, setNotificationsToken] = useState(null);
  const [notificationsPermissions, setNotificationsPermissions] = useState(null);

  useEffect(() => {
    const registerServiceWorker = async () => {
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.getRegistration();
        if (!registration) {
          try {
            const newRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
            console.log('Service Worker registered:', newRegistration);
          } catch (error) {
            console.log('Service Worker registration error:', error);
          }
        } else {
          console.log('Service Worker already registered:', registration);
        }
      }
    };

    registerServiceWorker();
    requestNotificationPermissionAndToken(false);
  }, []); 

  const requestNotificationPermissionAndToken = async (ask = true) => {
    try {

      if (!("Notification" in window)) {
        console.log('This browser does not support desktop notification');
        setNotificationsPermissions('unsupported');
        return 
      }

      let permission = Notification.permission

      if (permission === 'default' && ask){
        permission = await Notification.requestPermission();
      }

      setNotificationsPermissions(permission);

      if (permission === 'granted') {

        const vapidKey = 'BDwUY8Rix18wY_xJQZOnurmAUdcVY9xoyEAQzLrg7409zO0mnV3buW0PUCb20q7ReXFbCKmQ40_5iVtAj7Gg7bY';
        const currentToken = await getToken(messaging, { vapidKey });

        if (currentToken) {
          setNotificationsToken(currentToken);
        } else {
          console.log('Error getting notificationsToken');
        }

      }
    } catch (error) {
      console.error('Error requesting permissions & notifications token', error);
    }
  };

  const registerNotificationsToken = async (idToken) => {
      try {
        const response = await fetch(
          `https://script.google.com/macros/s/AKfycbxREPDO9_xArVTVk3trXhFg-u76nPzCES2MoIyBtsUPy7xTGYoNRClNu-AMkltdCSZx/exec?action=registernotificationstoken`,
          {
            method: "POST",
            body: JSON.stringify({
              id_token: idToken,
              notifications_token: notificationsToken
            }),
          }
        );
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.status !== "success") {
          throw new Error("API error");
        }
  
      } catch (error) {
        console.error("Error registering nofitifactions token:", error);  
      }
  }

  return [notificationsPermissions, notificationsToken, requestNotificationPermissionAndToken, registerNotificationsToken];
};

export default useNotifications;
